import { render, staticRenderFns } from "./cocktailsetting.vue?vue&type=template&id=7ecd9288&"
import script from "./cocktailsetting.vue?vue&type=script&lang=js&"
export * from "./cocktailsetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports